import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import { c as classNames } from '../../shared/bind-982142b2.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "container": "web_ui__Container__container",
  "styling-narrow": "web_ui__Container__styling-narrow",
  "styling-tight": "web_ui__Container__styling-tight",
  "styling-wide": "web_ui__Container__styling-wide",
  "width-content": "web_ui__Container__width-content",
  "width-wide": "web_ui__Container__width-wide"
};

var Styling = /*#__PURE__*/function (Styling) {
  Styling["Narrow"] = "narrow";
  Styling["Tight"] = "tight";
  Styling["Wide"] = "wide";
  return Styling;
}(Styling || {});
var Width = /*#__PURE__*/function (Width) {
  Width["Content"] = "content";
  Width["Wide"] = "wide";
  return Width;
}(Width || {});
var cssClasses = classNames.bind(styles);
var Container = function Container(_ref) {
  var _cssClasses;
  var styling = _ref.styling,
    width = _ref.width,
    children = _ref.children,
    testId = _ref.testId;
  var containerClass = cssClasses('container', (_cssClasses = {}, _defineProperty(_cssClasses, "styling-".concat(styling || ''), !!styling), _defineProperty(_cssClasses, "width-".concat(width || ''), !!width), _cssClasses));
  return /*#__PURE__*/jsx("div", {
    className: containerClass,
    "data-testid": testId,
    children: children
  });
};
Container.Styling = Styling;
Container.Width = Width;

export { Container as default };
//# sourceMappingURL=Container.js.map
